<ng-container *ngIf="icon">
  <svg-icon style="height: 26px" [svgStyle]="{'width.px': 18, 'height.px': 22}" src="/assets/icons/marker-black.svg"></svg-icon>
</ng-container>
<div>
  <span class="not-match">{{ chunk1 }}</span>
  <span class="match">{{ chunk2 }}</span>
  <span class="not-match">{{ chunk3 }}</span>
</div>
